module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/cup/3-60fc9f3787ee109c3ef71f1f4ba77c2f.jpg";